//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var Button = videojs.getComponent('Button');
//处理tab焦点问题，不需要聚焦
// Button.prototype.handleKeyDown = (e)=>{
//     e.target.blur();
// };
import myImage from "../myImage/myImage.vue"
import myVideo from "../myVideo/myVideo.vue"
import { companyCorpusList } from "../../api/api";
export default {
    components:{
        myImage,
        myVideo,
    },
  name: "FirmData",
  props: {
    companyID: Number | String,
    // src:String,
    // poster:String,
    // onPlayerReady:Function,
    // options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    // }
  },
  data() {
    return {
      list: [],
      imageIsOpen:false,
      videoIsOpen:false,
      videoImageUrl:''
    };
  },
  mounted() {
    this.companyCorpusList();
  },
  beforeDestroy() {},
  methods: {
    onBack() {
      console.log("----QA back");
      this.$emit("onBack", "preview");
    },
    companyCorpusList() {
      if (this.companyID <= 0) {
        return; //非企业账号
      }
      companyCorpusList(this.companyID, 1, 100).then((res) => {
        this.list = res.data.data;
        console.log("%c⧭", "color: #007300", res);
      });
    },
    onLookModal(type,item)
    {
        if(type == "image")
        {
            this.imageIsOpen = true;
            this.videoImageUrl = item.file;
        }
        else if(type == 'video')
        {
            this.videoIsOpen = true;
            this.videoImageUrl = item.file;
        }
        else
        {
            this.$wechat.miniProgram.navigateTo({
                url: `../documentView/documentView?url=${encodeURIComponent(item.file)}`,
                success: function () {
                console.log("跳转成功");
                },
            });
        }
    },
    onHideMyImage()
    {
        this.imageIsOpen = false;
    },
    onHideMyVideo()
    {
        this.videoIsOpen = false;
    },
  },
  watch: {
    companyID(val) {
      this.companyCorpusList();
    },
  },
};



// WEBPACK FOOTER //
// ./src/myComponents/Firm/FirmData.vue